import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CurrentMemberProvider } from '../../../auth/services/current-member-provider.service';
import { InternalMember } from '../../models/member/internal-member.model';

@Component({
  selector: 'def-profile-sheet',
  templateUrl: './def-profile-sheet.component.html',
  styleUrls: ['./def-profile-sheet.component.scss'],
})
export class DefProfileSheetComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();

  userFullName: string;
  userTitles: string;
  src: string;

  constructor(
    private router: Router,
    private currentMemberProvider: CurrentMemberProvider,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closed.emit(false);
      }
    });
  }

  ngOnInit(): void {
    if (this.currentMemberProvider.isAuthenticated()) {
      this.currentMemberProvider.get().subscribe(currentUser => this.setUserInformation(currentUser));
      this.fetchUserPicture();
    }
  }

  setUserInformation(user) {
    if (null !== user) {
      this.userFullName = user.getFullName();
      this.userTitles = user.title ? user.title.join(' ') : '';
    }
  }

  onError() {
    this.src = undefined;
  }

  private fetchUserPicture() {
    if (this.currentMemberProvider.isInternal()) {
      this.currentMemberProvider.get().subscribe(currentUser => {
        if (currentUser && currentUser instanceof InternalMember) {
          this.src = currentUser.photoUrl;
        }
      });
    }
  }

}
